import { Helmet } from "react-helmet-async";

interface RouteHeadProps {
  title: string;
  description: string;
  path: string; // origin-relative, must start with "/"
  ogType?: "website" | "article";
  jsonLd?: Record<string, unknown>;
}

const ORIGIN = "https://chroniclesofeurope.com";

/**
 * Per-route head tags. Overrides what's in index.html for JS-executing
 * crawlers (Googlebot etc.). The static index.html head remains the
 * fallback for social-preview crawlers that don't run JS.
 *
 * One canonical per route — we removed the static canonical from
 * index.html so there's no double-canonical conflict.
 */
export function RouteHead({ title, description, path, ogType = "website", jsonLd }: RouteHeadProps) {
  const url = `${ORIGIN}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={`${ORIGIN}/og-image.jpg`} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${ORIGIN}/og-image.jpg`} />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
